import {toast} from 'react-toastify'
import create from 'zustand'
import {generateFormLogic} from '../../../../../../_metronic/helpers/generate-form-logic'
import {
  FormAction,
  FormInput,
  FormProps,
  SelectData,
} from '../../../../../interfaces/form-action-interfaces'
import {ProgramCategorySingleResultInterface} from '../interfaces/program-category-single-result.interface'
import {
  ProgramCategoryData,
  ProgramCategoryResultInterface,
} from '../interfaces/program-cateogyr-result.interface'
import {
  GetAllProgramCategoryParam,
  GetAllProgramCategory,
  DeleteProgramCategory,
  SubmitProgramCategory,
  UpdateProgramCategory,
} from '../providers/program-category.provider'

interface ProgramCategoryState {
  programCategoryLoading: boolean
  programCategoryItems: ProgramCategoryData[]
  programCategorySelectDatas: SelectData[]
  programCategoryModel?: ProgramCategoryResultInterface
  getProgramCategorys: (params: GetAllProgramCategoryParam) => void
  onDelete: (id: string, params: GetAllProgramCategoryParam) => void
}

export const useProgramCategoryStore = create<ProgramCategoryState>((set, get) => ({
  programCategoryLoading: false,
  programCategoryItems: [],
  programCategorySelectDatas: [],
  programCategoryModel: undefined,
  getProgramCategorys: async (params: GetAllProgramCategoryParam) => {
    set({programCategoryLoading: true})
    const response = await GetAllProgramCategory(params)
    set({programCategoryModel: response})
    if (response.status) {
      if (response.data.items.length > 0) {
        let transformDatas: SelectData[] = []
        for (const item of response.data.items) {
          transformDatas.push({
            label: item.name,
            value: item.id,
          })
        }
        set({
          programCategoryItems: response.data.items,
          programCategorySelectDatas: transformDatas,
        })
      } else {
        set({
          programCategoryItems: [],
          programCategorySelectDatas: [],
        })
      }
    } else {
      set({
        programCategoryItems: [],
        programCategorySelectDatas: [],
      })
    }
    set({programCategoryLoading: false})
  },
  onDelete: async (id: string, params: GetAllProgramCategoryParam) => {
    const confirm = window.confirm('Apakah anda yakin ingin menghapus data ini?')
    if (confirm === true) {
      set({programCategoryLoading: true})
      const response = await DeleteProgramCategory(id)
      if (response.status) {
        toast.success(response.message)
      } else {
        toast.error(response.message)
      }
      get().getProgramCategorys(params)
      set({programCategoryLoading: false})
    }
  },
}))

const formInitialState = {
  loading: false,
  forms: [],
  formParam: undefined,
  formLoading: undefined,
  submitDone: undefined,
}

export interface ProgramCategoryFormState {
  field?: ProgramCategoryData
  setField?: (item: ProgramCategoryData) => void
  forms?: FormInput[]
  setForms?: (index: number, value: any) => void
  generateForms: (formParam: FormProps) => void
  setFormSelectData: (index: number, selectData: SelectData[]) => void
  formParam: FormProps
  reset: () => void
  formLoading?: boolean
  submitDone?: boolean
  onSubmit: () => void
}

export const useProgramCategoryFormStore = create<ProgramCategoryFormState>((set, get) => ({
  field: undefined,
  setField: (item: ProgramCategoryData) => {
    set({field: item})
  },
  formParam: undefined,
  setForms: (index: number, value: any) => {
    const forms = [...get().forms]
    forms[index] = {
      ...forms[index],
      value: value,
    }
    set({forms: forms})
  },
  generateForms: (formParam: FormProps) => {
    set({formParam: formParam})
    let forms: FormInput[] = []
    forms = [
      {
        id: 'name',
        title: 'Name',
        placeholder: 'Name...',
        type: 'text',
        name: 'name',
        value: get().field?.name ?? '',
        disabled: formParam.action === FormAction.VIEW ? true : false,
        required: true,
      },
      {
        id: 'icon',
        title: 'Icon',
        placeholder: 'Choose file...',
        type: 'file-upload-v2',
        name: 'icon',
        value: get().field?.icon ?? '',
        disabled: formParam.action === FormAction.VIEW ? true : false,
        isImage: true,
        required: false,
      },
      {
        id: 'is_home',
        title: 'Show in platform?',
        placeholder: 'Show in platform?',
        type: 'checkbox',
        name: 'is_home',
        value: get().field?.is_home ?? false,
        disabled: formParam.action === FormAction.VIEW ? true : false,
        required: true,
      },
    ]

    set({forms: forms})
  },
  reset: () => {
    set(formInitialState)
    return
  },
  onSubmit: async () => {
    let form = {}
    for (const item of get().forms) {
      form = {
        ...form,
        [item.name]: generateFormLogic(item.type, item.value),
      }
    }

    let res: ProgramCategorySingleResultInterface = {}
    if (get().formParam.action === FormAction.CREATE) res = await SubmitProgramCategory(form)
    if (get().formParam.action === FormAction.UPDATE)
      res = await UpdateProgramCategory(get().formParam?.id, form)

    console.log(res)
    if (res.status) {
      toast.success(res.message)
      set({submitDone: true, formLoading: false, field: undefined})
      return
    } else {
      toast.error(res.message)
      set({submitDone: false, formLoading: false})
      return
    }
  },
  setFormSelectData: (index: number, selectData: SelectData[]) => {
    const forms = [...get().forms]
    forms[index] = {
      ...forms[index],
      selectData: selectData,
    }
    set({forms: forms})
  },
}))
